import {combineReducers} from 'redux'
import placeInfo from './placeInfoReducer'
const rootReducer=combineReducers({
placeInfo
}
)
export default rootReducer;
